import Vue from "vue";

const dotationBox = () => {
  const donationBoxPrimary = document.querySelector('.donation_box--primary');

  if (donationBoxPrimary) {
    new Vue({
      name: 'DonationBoxPrimary',
      el: donationBoxPrimary,
      data() {
        return {
          dotationValue: 50,
          inputValue: null,
          dotationValueValidation: false,
          payType: null,
          step: 1,
        };
      },
      watch: {
        inputValue() {
          if(this.inputValue) {
            this.dotationValue = false;
            this.dotationValueValidation = false;
          } else if (!this.dotationValue) {
            this.dotationValue = 50;
          }
        },
        dotationValue() {
          if(this.dotationValue) {
            this.inputValue = null;
            this.dotationValueValidation = false;
          }
        },
      },
      methods: {
        pay(type) {
          this.payType = type;
          const dotationValue = this.dotationValue;
          const inputValue = this.inputValue;

          if (dotationValue || (inputValue && inputValue != 0)) {
            const url = this.$refs.url.getAttribute('data-url');
            const paramValue = dotationValue ? `dotationValue=${dotationValue}`:
              `inputValue=${inputValue}`;
            const params = `?${paramValue}&payType=${type}`;
            window.location = `${url}${params}`;
          } else {
            this.dotationValueValidation = true;
          }
        },
      }
    });
  }
}

export default dotationBox;


// WEBPACK FOOTER //
// ./assets/js/partials/dotationBoxPrimary.js